<template>
  <div>
    <div id="header">
      <b-button size="sm" class="float-left" @click="insert_task">New</b-button>
      <span class="h5">{{ list_title }}</span><span v-if="msg"> ({{ msg }})</span>
    </div>
    <ul id="list" class="list-group" @click="clicked">
      <draggable v-model="tasks" handle=".drag-handle" @end="drag_moved">
        <li v-for="(task, index) in tasks" :key="task.id" class="py-1 item list-group-item list-group-item-action" data-toggle="list" :data-idx="index" :data-id="task.id" :class="{ active: task.id === ids[cursor], completed: task.status==='completed' }" @dblclick="doubleclicked">
          <span class="drag-handle fas fa-grip-lines" :class="[ 'indent-' + task.level ]" /> &nbsp;
          <span v-if="task.status==='completed'" class="far fa-check-square" title="checked" aria-hidden="true" @click="check(0, task)" />
          <span v-else class="far fa-square" title="unchecked" aria-hidden="true" @click="check(1, task)" />
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span class="item-title" :class="{ completed: task.status==='completed' }" v-html="markdown_title(task)" />
          <span v-if="task.due" class="badge badge-info float-right" :class="{ 'badge-danger': task_due_over(task) }">{{ task_due(task) }}</span>
          <div v-if="task.notes" class="list-notes-wrap"><br><span class="list-notes">{{ task.notes }}</span></div>
        </li>
      </draggable>
    </ul>

    <!-- TaskDetail id="detail"></TaskDetail -->
    <b-modal id="detail" ref="detail" v-model="showDetail" class="detail"
             size="lg" :title="item.title" ok-title="Save"
             hide-header-close
             no-fade no-close-on-esc no-close-on-backdrop
             @keypress="dialog_keypress"
             @ok="close_detail(1)" @cancel="close_detail(0)" @close="close_detail(0)">
      <template slot="modal-title">
        <div class="form-inline">
          <span v-if="item.status==='completed'" class="far fa-check-square" title="checked" aria-hidden="true" @click="check(0, item)" />
          <span v-else class="far fa-square" title="unchecked" aria-hidden="true" @click="check(1, item)" />
          <b-form-input v-if="dialog_edit" ref="title-edit"
                        v-model="item.title"
                        @keypress.enter="title_keypress_enter"
                        @keyup.enter.stop.prevent="title_keyup_enter" />
          <!-- eslint-disable-next-line vue/no-v-html -->
          <span v-else ref="title-text" class="item-title" :class="{ completed: item.status==='completed' }" @click="flip_edit" v-html="compiledTitle" />
        </div>
      </template>
      <div>
        <div class="notes">
          <!-- [TAB] はフォーカス移動。0x09 入力は Shift+[TAB] にする -->
          <b-form-textarea v-if="dialog_edit" ref="notes-edit"
                           v-model="item.notes"
                           rows="3" max-rows="20"
                           @keypress.enter="hook_notes_enter" />
          <!-- eslint-disable-next-line vue/no-v-html -->
          <div v-else ref="notes-text" class="item-notes" @click="flip_edit" v-html="compiledNotes" />
        </div>
      </div>
      <div class="form-inline">
        <b-form-select v-if="dialog_edit" v-model="tasklistsSelected" :options="tasklistsSelect" />
        <div v-else class="tasklists-selected" @click="flip_edit">{{ detail_selected_title() }}</div>
      </div>
      <div>
        <div class="meta">
          <div class="text-right small">Id: {{ item.id }}</div>
          <div class="text-right small">Updated: {{ item.updated }}</div>
          <div v-if="item.due" class="text-right small">Due: {{ item.due }}</div>
          <div v-if="item.parent" class="text-right small">Parent: {{ item.parent }}</div>
          <div v-if="item.links" class="text-right small">Links: {{ JSON.stringify(item.links) }}</div>
          <div v-if="item.deleted" class="text-right small">Deleted</div>
          <div v-if="item.hidden" class="text-right small">Hidden</div>
          <div v-if="item.completed" class="text-right small">Completed: {{ item.completed }}</div>
          <div class="text-right small">Modified: {{ detail_modified() }}</div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
/* eslint-disable no-console */
import BModal from 'bootstrap-vue/es/components/modal/modal'
import draggable from 'vuedraggable'
// import TaskDetail from './TaskDetail'
import marked from 'marked'
export default {
  components: {
    // TaskDetail,
    draggable,
    BModal
  },
  data () {
    return {
      taskLists: [],
      tasklist: null,
      tasklistsSelect: [],
      tasklistsSelected: null,
      current_tasklist_id: null,
      list_title: '',
      msg: '',
      cursor: 0,
      showDetail: false,
      item: {},                 // 現在選択されて detail に表示されているもの
      old_item: {},
      dialog_edit: false,
      tasks: [],
      tasks_last_updated: "",
    }
  },
  computed: {
    compiledTitle: function () {
      return marked.inlineLexer(this.item.title || '', [])
    },
    compiledNotes: function () {
      return marked(this.item.notes || '')
    }
  },
  mounted () {
    console.log('JK: Tasks mounted ') //, this.initClient)

    let p = this.$gapi.authorize()
    p.then((r) => {
      console.log('then', r)

      this.listTasks()
      this.$emit('mounted')
    })
  },
  updated () {
    /*
    console.log('Tasks#updated() current id=' + this.current_tasklist_id)
    console.log('Tasks#updated() next id=' + this.tlid())
    this.current_tasklist_id = this.tlid()
    this.$nextTick(() => {
      console.log('JK: Tasks#updated() > nextTick() tlid=' + this.current_tasklist_id)
    })
    */
    if (this.current_tasklist_id !== this.tlid()) {
      this.current_tasklist_id = this.tlid()
      this.$nextTick(() => {
        console.log('JK: Tasks#updated() > nextTick() tlid=' + this.current_tasklist_id)
        this.listTasks()
      })
    }
  },
  created () {
    window.addEventListener('keyup', this.move_by_key)
    window.addEventListener('keydown', this.window_keydown)
  },
  destroyed () {
    window.removeEventListener('keyup', this.move_by_key)
    window.removeEventListener('keydown', this.window_keydown)
  },
  // TaskLists の updated で更新されるかを見るようにしていたが、Task の中身が更新されただけだと TaskLists[].updated は更新されないっぽい。
  methods: {
    tlid: function () { return this.$route.params.taskListId },
    listTasks: function () {
      console.log('Tasks: listTasks()')
      const tlid = this.tlid()
      this.$gapi.listTasks(tlid).then(items => {
        this.sortLists(items)
        this.refresh_tasks()
        this.current_tasklist_id = tlid
        this.update_tasklist_title()
      })
    },
    sortLists (items) {
      const sortF = (a, b) => { return a.position < b.position ? -1 : a.position > b.position ? 1 : 0 }
      let parent = {}, seen = {}
      let tasks = [], latest = ""
      items.forEach(item => {
        if (latest < item.updated) {
          latest = item.updated
        }
        if (item.parent) {
          if (parent[item.parent]) {
            parent[item.parent].push(item)
          } else {
            parent[item.parent] = [ item ]
          }
        } else {
          seen[item.id] = 1
          tasks.push(item)
        }
      })
      tasks = tasks.sort(sortF).map(e => { e.level = 0; return e })
      for (;;) {
        if (Object.keys(parent).length === 0) {
          break
        }
        let tryid = Object.keys(parent).find(p => p in seen)
        if (!tryid) {
          console.log('Unexpected (親がいない？):', parent)
        } else {
          let arr = parent[tryid]                   // 差し込む子供配列
          let pitem = tasks.find(e => e.id === tryid) // 親
          let pidx  = tasks.findIndex(e => e.id === tryid) // 親の idx
          arr = arr.map(e => { e.level = pitem.level + 1; return e })
          arr.unshift(0)
          arr.unshift(pidx + 1)      // (pidx, 0, arr...)
          tasks.splice.apply(tasks, arr)
          delete parent[tryid]
          seen[tryid] = 1
        }
      }
      this.tasks = tasks
      this.tasks_last_updated = latest
    },
    // タイトルメッセージ更新
    refresh_tasks () {		// this.tasks が更新されたら呼ぶこと
      this.ids = this.tasks.map(x => x.id)
      let act = this.tasks.filter(e => !e.completed).length
      let ina = this.tasks.filter(e => e.completed).length
      this.msg = `${act} active tasks, ${ina} inactive tasks`
    },
    task_due (task) {
      return new Date(task.due).toLocaleString('ja-JP').replace(/:00$/, '')
    },
    task_due_over (task) {
      return new Date(task.due) < new Date();
    },
    markdown_title (task) {
      return marked.inlineLexer(task.title || '', [])
    },
    flip_edit () {
      console.log('flip edit from', this.dialog_edit)
      this.dialog_edit = !this.dialog_edit
      setTimeout(() => { if (this.$refs['title-edit']) { this.$refs['title-edit'].focus() } }, 0)
    },
    title_keypress_enter (ev) {
      console.log('title_keydown', ev.keyCode)
      if (ev.keyCode === 13) {
        this._enter_pressed = true
      }
    },
    title_keyup_enter (/* ev */) {
      if (this._enter_pressed) {
        this.$refs['title-edit'].blur()
        this._enter_pressed = false
        this.$refs['notes-text'].click()
      }
    },
    check: function (checking, item) {
      console.log('check', checking, item, item.id)
      let copied = JSON.parse(JSON.stringify(item))
      if (checking) {
        item.status = 'completed'
        copied.status = 'completed'
        copied.completed = (new Date()).toJSON()
        this.do_update(item, copied)
      } else {
        item.status = 'needsAction'
        copied.status = 'needsAction'
        this.do_update(item, copied)
      }
    },
    do_update: function (item, params) {
      let modified = 0
      let copied = JSON.parse(JSON.stringify(item))
      console.log('do_update params=', params)
      for (const key in params) {
        if (this.old_item[key] !== params[key]) {
          console.log('diff', key, [ this.old_item[key],  params[key] ])
          modified++
          copied[key] = params[key]
        }
      }
      if (!modified) {
        console.log('do_update() no modified.')
        return
      }
      copied['taskListId'] = this.tlid()
      copied['taskId'] = item.id
      let r = this.$gapi.updateTask(copied)
      console.log('API update ret', r)
      r.then((value) => {
        console.log('API done', value)
      }, (reason) => {
        console.log('API failed', reason)
      })
    },
    clicked: function (ev) {
      console.log('clicked', ev.target, ev)
      let tgt = ev.target.tagName === 'LI' ? ev.target : ev.target.parentElement.tagName === 'LI' ? ev.target.parentElement : ev.target.parentElement.parentElement.tagName === 'LI' ? ev.target.parentElement.parentElement : null
      if (tgt) {
        tgt.classList.add('active')
        this.cursor = parseInt(tgt.dataset.idx)
        this.check_view(tgt)
      }
    },
    // https://github.com/vtimofeev/vue-check-view/blob/master/index.js
    check_view (el) {
      let viewportTop = window.pageYOffset,
          viewportBottom = window.pageYOffset + window.document.documentElement.clientHeight
      let rect = el.getBoundingClientRect(),
          elementTop = rect.top + viewportTop,
          elementBottom = elementTop + rect.height,
          topIn = elementTop > viewportTop && elementTop < viewportBottom,
          bottomIn = elementBottom > viewportTop && elementBottom < viewportBottom
      // console.log('check_view', viewportTop, viewportBottom, rect, topIn, bottomIn)
      return [ topIn, bottomIn, -window.document.documentElement.clientHeight, rect.top ]
    },
    hook_notes_enter: function (ev) {
      console.log('hook_notes_enter', ev)
      if (ev.keyCode === 13 && ev.shiftKey) {
        if (this.$refs['notes-edit']) {
          console.log('exit from notes textarea 2', ev.target)
          this.$refs['notes-edit'].blur()
          ev.preventDefault()
        }
      }
    },
    open_detail: function () {
      this.item = JSON.parse(JSON.stringify(this.tasks[this.cursor]))
      this.showDetail = true
      this.tasklistsSelected = this.tlid()
      this.dialog_edit = true
      this.$nextTick(() => {
        console.log('open_detail next 1st notes-text=%s, notes-edit=%s', typeof this.$refs['notes-text'], typeof this.$refs['notes-edit'])
        if (this.item.title) {
          if (this.$refs['notes-text']) {
            this.$refs['notes-text'].click()
            this.$nextTick(() => {
              this.$refs['notes-edit'].focus()
            })
          } else if (this.$refs['notes-edit']) {
            // なぜか $nextTick() だとうまくいかない
            setTimeout(() => this.$refs['notes-edit'].$el.focus(), 0)
          } else {
            console.log('No $refs.notes-text')
          }
        } else {
          console.log(0, this.$refs);
          if (this.$refs['title-text']) {
            this.$refs['title-text'].click()
            console.log(1);
            this.$nextTick(() => {
              console.log(2);
              this.$refs['title-edit'].focus()
            })
          } else if (this.$refs['title-edit']) {
            console.log(3);
            this.$refs['title-edit'].focus()
            setTimeout(() => {
              console.log(4);
              this.$refs['title-edit'].focus()
            }, 300);
          } else {
            console.log('No $refs.title-text')
          }
        }
      })
    },
    close_detail: function (do_save) {
      console.log('close_detail', do_save)
      this.showDetail = false
      this.dialog_edit = false
      if (do_save) {
        this.$emit('update')
        let changed = {}
        let item = this.tasks[this.cursor];
        ['title', 'notes'].forEach(key => {
          if (this.item[key] !== item[key]) {
            changed[key] = item[key] = this.item[key]
          }
        })
        console.log("close_detail to do_update", this.item, changed)
        this.do_update(this.item, changed)
        if (this.tasklistsSelected !== this.tlid()) {
          console.log('Move item to another tasklist', this.tasklistsSelected)
          let item = this.item
          item.taskListId = this.tasklistsSelected
          let r = this.$gapi.insertTask(item)
          console.log(r, 'then delete')
          let s = this.$gapi.deleteTask({ taskListId: item.taskListId, taskId: item.id })
          console.log('done', s)
          this.tasks = this.tasks.filter((e, i) => i !== this.cursor)
        }
      }
    },
    insert_task () {
      if (this.showDetail) {
        return
      }
      let r = this.$gapi.insertTask({ taskListId: this.tlid() })
      // 先に空のデータでダイアログを出して入力開始できるようにする
      this.tasks.unshift({ kind: "pending", title: "" })
      this.cursor = 0
      this.open_detail()        // このタイミングで this.item が設定される
      r.then((rv) => {
        console.log('insert then', rv)
        console.log('vals', rv.kind, rv.status, rv.position)
        // { kind: "tasks#task", id: ..., etag: ..., title: "", updated: "2019-...", selfLink: ..., position: "00000000000000000000", status: "needsAction" }
        if (this.tasks[0].kind === "pending") {
          rv.title = this.item.title
          this.tasks[0] = rv
          this.item = JSON.parse(JSON.stringify(this.tasks[this.cursor]))
        } else {
          console.log("Unexpected.  Re-ordered during API call ?", this.tasks[0].kind, this.tasks[0].id)
        }
        console.log('tasks[0]', this.tasks[0])
        this.refresh_tasks()
      })
    },
    window_keydown (ev) {
      if ((ev.keyCode === 38 || ev.keyCode === 40) && !this.showDetail) {
        ev.preventDefault()     // prevent native scroll by cursor keys
      }
    },
    dialog_keypress (ev) {
      console.log('dialog keypress', ev)
    },
    move_by_key: function (ev) {
      let memo = { 13: 'Enter', 16: 'Shift', 17: 'Ctrl', 18: 'Alt', 27: 'Esc', 38: 'Up', 40: 'Down',
                   78: 'n', 91: 'Win', 191: '/' }
      if (!memo[ev.keyCode]) {
        console.log('keyup keycode=', [ ev.keyCode, ev.shiftKey, ev.ctrlKey ])
      }
      if (ev.keyCode === 38 && !this.showDetail) {
        this.cursor = (this.cursor + this.ids.length - 1) % this.ids.length
        let el = this.$el.querySelector('li[data-idx="' + this.cursor + '"]')
        // console.log(el.classList)
        let cv = this.check_view(el)
        if (!cv[0]) {
          // console.log("Scroll out")
          window.scrollBy(0, cv[2] / 2)
        }
      }
      if (ev.keyCode === 40 && !this.showDetail) {
        this.cursor = (this.cursor + 1) % this.ids.length
        let el = this.$el.querySelector('li[data-idx="' + this.cursor + '"]')
        let cv = this.check_view(el)
        if (!cv[1]) {
          // console.log("Scroll out")
          window.scrollBy(0, cv[3] / 2)
        }
      }
      if (ev.keyCode === 78) {
        this.insert_task()
      }
      if (ev.keyCode === 191 && ev.ctrlKey) {
        this.flip_edit()
      }
      if (ev.keyCode === 27) {
        if (this.showDetail) {
          if (this.dialog_edit) {
            this.flip_edit()
          } else {
            this.close_detail(0)
            console.log('esc pressed, close modal as cancel')
          }
        } else {
          console.log('esc pressed, but no detail modal?')
        }
      }
      if (ev.keyCode === 13) {
        if (!this.dialog_edit) {
          // this.item = this.tasks[this.cursor]
          console.log('Toggle dialog', this.item, this.cursor, this.showDetail, this.dialog_edit)
          if (this.showDetail) {
            this.close_detail(1)
          } else {
            this.open_detail()
          }
          ev.preventDefault()
        }
      }
    },
    doubleclicked: function (ev) {
      console.log('dblclick: ', ev.target.dataset.idx)
      this.clicked(ev)
      this.open_detail()
    },
    inject_taskLists: function (taskLists) {
      const tlid = this.tlid()
      console.log('inject_taskLists', taskLists, tlid)
      this.taskLists = taskLists
      this.update_tasklist_title()
    },
    update_tasklist_title: function () {
      console.log('update_tasklist_title', this.taskLists.length)
      const tlid = this.tlid()
      const tl = this.taskLists
      if (tl.length) {
        let list = tl.find(el => el.id === tlid)
        if (list) {
          this.list_title = list.title
        }
        this.tasklistsSelect
          = tl.map(e => ({ value: e.id, text: e.id === tlid ? e.title : 'Move to ' + e.title }))
      } else {
        console.log('empty taskLists')
      }
    },
    // draggable
    drag_moved (ev) {
      if (ev.oldIndex === ev.newIndex) {
        return
      }
      let item = this.tasks[ev.newIndex]
      let update = { taskListId: this.tlid(), taskId: item.id }
      if (ev.newIndex !== 0) update['previous'] = this.tasks[ev.newIndex - 1].id
      item.level = 0
      this.$gapi.moveTask(update)
    },
    detail_selected_title () {
      if (this.showDetail) {
        let item = this.tasklistsSelect.find(e => e.value === this.tasklistsSelected)
        return item.text
      }
      return ''
    },
    detail_modified () {
      const item = this.tasks[this.cursor]
      if (!item) return ''
      let mod = []
      let a = [ 'status', 'title', 'notes', 'due' ]
      a.forEach(e => {
        this.item[e] !== item[e] && mod.push(e)
      })
      this.tasklistsSelected !== this.tlid() && mod.push('tasklist')
      return mod.join(', ')
    },
    // TaskLists の更新チェックから呼ばれる。
    check_update () {
      console.log(`Tasks#check_update() latest=${this.tasks_last_updated}`)
      const tlid = this.tlid()
      this.$gapi.listTasks(tlid).then(items => {
        let latest = ""
        items.forEach(item => {
          if (latest < item.updated) {
            latest = item.updated
          }
        })
        if (latest > this.tasks_last_updated) {
          console.log(`Tasks#check_update() found updates: ${this.tasks_last_updated} to ${latest}`)
          this.listTasks()
        }
      });
    },
  },
}
// status: "needsAction" or "completed"
// hidden: boolean
// deleted: boolean
// updated: datetime
// position: string
// title, notes: string
// due: datetime
</script>
<style scoped>
#header {
    padding: 1em 0;
}
/* 相対的な .small よりはきりのいいフォントサイズにしたい */
#list {
    font-size: 10pt;
}
.item {
    border: 1px solid #ccc;
    text-align: left;
}
.detail {
    text-align: left;
}
.task_title {
    margin-left: 0.33em;
}
li.completed {
    background-color: #eee;
}
li.completed.active {
    background-color: #cce;
}
li .badge {
    font-size: 100%;
}
span.completed {
    text-decoration: line-through;
}
.modal-title input {
    line-height: 1.5;
    font-size: 1.25rem;
    padding: 0.375rem 0.25rem;
    width: calc(100% - 20px);
    height: 1.5em;              /* override .form-control style */
}
.item-title {
    margin-left: 0.25em;
}
.meta {
    margin-top: 0.25em;
}
.indent-1 {
    margin-right: 1.5em;
}
.indent-2 {
    margin-right: 3em;
}
.indent-3 {
    margin-right: 4.5em;
}
.tasklists-selected {
    border: 1px solid #ccc;
    padding: 0.2em 1em;
}
.list-notes-wrap {
    line-height: 0.9;
    margin-top: -0.5em;
    margin-left: 3.6em;
    color: #ccc;
    font-size: smaller;
    max-height: 3em;
    overflow: hidden;
}
.list-notes {
}
</style>
<style>
li.list-group-item {
    padding: 0.75rem 0.5rem;
}
.modal-title {
    width: calc(100% - 20px);
}
</style>
